/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const question_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.75 7.429c0-2.39 2.106-4.332 4.467-4.168 2.384.164 4.177 2.398 3.851 4.743a4.215 4.215 0 0 1-2.746 3.366c-1.743.616-1.393 2.671-1.393 4.13m-.577 4.5h1.31m.09 0c0 .437-.31.747-.754.747a.718.718 0 0 1-.747-.747c0-.443.31-.753.747-.753.443 0 .753.31.753.753Z"
    />
  </svg>
)
export default question_medium
